export default "__VITE_ASSET__b5994305__"